import { Directive, inject } from '@angular/core';
import {
  FilterView,
  FilterViewProviderDirective,
  ListViewProviderDirective
} from '@ntap/core';

@Directive({
  selector: '[odabirJedinicaFilterViewProvider]',
  providers: [
    {
      provide: FilterViewProviderDirective,
      useExisting: OdabirJedinicaFilterViewProviderDirective
    }
  ]
})
export class OdabirJedinicaFilterViewProviderDirective extends FilterViewProviderDirective<FilterView> {
  private listviewProvider = inject(ListViewProviderDirective);

  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};

  override runSearch(filterData: any) {
    const parentItemProps = {
      $parentId: (this.listviewProvider.viewState as { $parentId: number })[
        '$parentId'
      ],
      $parentType: (this.listviewProvider.viewState as { $parentType: string })[
        '$parentType'
      ],
      $itemType: (this.listviewProvider.viewState as { $itemType: string })[
        '$itemType'
      ]
    };
    const updatedFilterData = { ...filterData, ...parentItemProps };

    this.currentViewName = 'jedinica_gradiva';
    this.currentViewState = { ...parentItemProps };
    this.currentViewStateFilter = { ...parentItemProps };

    this.setViewData(updatedFilterData);
  }
}
